import React from 'react';
import { IBrandingProps } from './IBrandingProps';

const Branding: React.FC<IBrandingProps> = ({ onload }) => {
   return (
      <div className='calculator-branding' id='calculator-branding'>
         <img alt='Powered By AFFLUENCER' src='/calculator/AFFLUENCER.png' onLoad={onload} />
      </div>
   );
};

export default Branding;
